import "./style.scss";

import type { CSSProperties } from "react";

import variables from "../../../assets/styles/_variables.module.scss";

interface ITitleSeparation {
    title: string;
    style?: CSSProperties;
    titleStyle?: CSSProperties;
    description?: string;
    extraComponent?: JSX.Element;
}

/**
 * Title component with horizontal separation line. Typically used in forms to create different visual blocks.
 */
const TitleSeparation = ({ title, titleStyle, style, description, extraComponent }: ITitleSeparation) => {
    return (
        <div style={style}>
            <div style={{ ...styles.containerStyle }}>
                <h3 style={{ ...styles.subtitleStyle, ...titleStyle }}>{title}</h3>
                {extraComponent && extraComponent}
                <div style={{ ...styles.horizontalLine }}></div>
            </div>
            {description && <p style={styles.descriptionLine}>{description}</p>}
        </div>
    );
};

export default TitleSeparation;

/** STYLES */
const styles = {
    subtitleStyle: {
        fontSize: "1rem",
        fontWeight: "500",
        color: "black",
    },
    containerStyle: {
        display: "flex",
        alignItems: "center",
        gap: "0.5rem",
    },
    horizontalLine: {
        height: "1px",
        background: "#eaeaea",
        borderRadius: "3px",
        flexGrow: "1",
    },
    descriptionLine: {
        fontSize: "0.75rem",
        color: variables["foreground"],
    },
};
